import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=4ef45b55&scoped=true"
import script from "./CustomDialog.vue?vue&type=script&lang=js"
export * from "./CustomDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef45b55",
  null
  
)

export default component.exports